import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: function() {
		return {
			currency: 'CHF',
			price: ''
		};
	}
});

